import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router'
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireFunctions } from '@angular/fire/functions';
import * as firebase from 'firebase/app';
import 'firebase/auth'

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public userData: any; // Save logged in user data
  public userDataFact: any;
  public usuario: any;

  constructor(
    private db: AngularFirestore,
    private afAuth: AngularFireAuth,
    private functions: AngularFireFunctions,
    public router: Router,
    public ngZone: NgZone // Servicio NgZone para eliminar la advertencia de alcance externo
  ) { }
  fbProvider = new firebase.default.auth.FacebookAuthProvider();

  // ------------------------------------------------------------------------------- Sign In EMAIL + PASSWORD

  SignInInstructor(email, password) {
    return this.afAuth.signInWithEmailAndPassword(email, password)
      .then((result) => {
        this.db.collection("usuariosInstructor").doc(result.user.uid).ref.get().then((doc) => {
          if (doc.exists) {
            result.user.getIdTokenResult().then((idTokenResult) => {
              const token = idTokenResult.claims.claim;
              const user = doc.data();
              localStorage.setItem('user', JSON.stringify(user));
              localStorage.setItem('token', JSON.stringify(token));
              this.ngZone.run(() => {
                this.router.navigate(['/inst/resumen', user['instructorId']]).then(() => {
                  location.reload()
                });
              });
            })
          } else {
            alert('no exites como instructor')
          }
        }).catch(error => {
          alert(error);
        });
      }).catch((error) => {
        window.alert(error.message)
      })
  }

  SendVerificationMail() {
    return firebase.default.auth().currentUser.sendEmailVerification()
      .then(() => {
        this.router.navigate(['verify-email-address']);
      })
  }

  ForgotPassword(passwordResetEmail) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        window.alert('Password reset email sent, check your inbox.');
      }).catch((error) => {
        window.alert(error)
      })
  }

  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return (user !== null && user.emailVerified !== false) ? true : false;
  }

  // ------------------------------------------------------------------------------- Sign In GOOGLE + FACEBOOK

  GoogleAuth() {
    return this.AuthLogin(new firebase.default.auth.GoogleAuthProvider());
  }

  FacebookAuth() {
    return this.AuthLogin(new firebase.default.auth.FacebookAuthProvider());
  }

  async AuthLogin(provider) {
    const userCredentials = await this.afAuth.signInWithPopup(provider);
    const credential = userCredentials.credential;
    const user = userCredentials.user;
    console.log(user.uid);
    const userRef = this.db.collection('usuarios').doc(user.uid);
    const RefDatosFact = this.db.collection('usuariosDatosFacturacion').doc(user.uid);
    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      emailVerified: user.emailVerified,
      nombreCompleto: user.displayName,
      genero: "",
      fechaNacimiento: "",
      paisActual: "",
      profesion: "",
      especialidad: "",
      anosExperiencia: "",
      situacionLaboral: "",
      industria: "",
      empleador: "",
      titulo: "",
      fechaRegistro: new Date,
      cantCursos: 0,
    }

    const datosFact = {
      razonSocial: user.displayName,
      nif: "",
      direccion: "",
      cp: "",
      pais: "",
      email: user.email,
      tlf: "",
    }

    const doc = await userRef.ref.get();
    if (doc.exists) {
      console.log("usuario existente");
      localStorage.setItem('user', JSON.stringify(doc.data()));
      const idTokenResult = await user.getIdTokenResult();
      const token = idTokenResult.claims.claim;
      // console.log(token);
      if (typeof token == 'string') {
        localStorage.setItem('token', JSON.stringify(token))
      } else {
        localStorage.setItem('token', null)
      }
      location.reload()
    } else {
      // console.log("usuario no existente");
      await userRef.set(userData, { merge: true })
        .catch((error => console.log(error)));
      await RefDatosFact.set(datosFact, { merge: true })
        .catch((error => console.log(error)));
      // console.log("correo: "+user.email)
      await this.functions.httpsCallable('addEstudianteRole')({email: user.email }).toPromise()
        .catch((error => console.log(error)));
      await this.afAuth.signInWithCredential(credential);
      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('token', JSON.stringify("estudiante"));
      location.reload()
    }
  }

  // ------------------------------------------------------------------------------- SIGN IN USUARIO INSTRUCTOR

  SignUpInstructor(email, password, nombre, docName) {
    return this.afAuth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        this.functions.httpsCallable('addInstructorRole')({
          email: email,
        }).toPromise().then(() => {
          this.router.navigate(['spinner'])
          this.SetUserDataInstructor(result.user.uid, password, email, nombre, docName);
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error);
      })
  }

  SetUserDataInstructor(uid, password, email, nombre, docName) {
    const userRef: AngularFirestoreDocument<any> = this.db.collection('usuariosInstructor').doc(uid)
    const userData = {
      uid: uid,
      instructorId: docName,
      email: email,
      password: password,
      nombre: nombre,
      fechaRegistro: new Date,
    }

    userRef.ref.get().then(doc => {
      if (doc.exists) {
        // console.log('usuario instructor existente')
        return location.reload()
      } else {
        // console.log('usuario instructor no existente')
        return userRef.set(userData, {
          merge: true
        }).then(() => {
          this.db.collection('instructores').doc(docName).set({
            usuarioInstructorId: uid
          }, { merge: true })
        }).then(() => {
          const instructor = 'instructor'
          localStorage.setItem('user', JSON.stringify(userData));
          localStorage.setItem('token', JSON.stringify(instructor));
          this.afAuth.signInWithEmailAndPassword(email, password).then(() => {
            this.router.navigate(['inst', docName]).then(() => {
              location.reload();
            });
          }).catch((error) => {
            console.log(error)
          })
        }).catch((error) => {
          console.log(error)
        })
      }
    }).catch((error) => {
      console.log(error);
    })
  }

  // ------------------------------------------------------------------------------- SIGN IN USUARIO EMPRESA

  SignUpUsuarioEmpresa(email, password, nombreCompleto, empresaNombre, empresaId) {
    return this.afAuth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign 
         up and returns promise */
        this.SetUserDataEmpresa(result.user, nombreCompleto, empresaNombre, empresaId);
        // this.SendVerificationMail();
      }).catch((error) => {
        if (error.code == 'auth/account-exists-with-different-credential') {
          alert('entre')
        }
      })
  }

  SetUserDataEmpresa(user, nombreCompleto, empresaNombre, empresaId) {
    // console.log(user.uid)
    const userRef: AngularFirestoreDocument<any> = this.db.collection('usuariosEmpresa').doc(user.uid)
    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      emailVerified: user.emailVerified,
      nombreCompleto: nombreCompleto,
      empresaId: empresaId,
      empresaNombre: empresaNombre,
      genero: "",
      fechaNacimiento: "",
      paisActual: "",
      profesion: "",
      especialidad: "",
      anosExperiencia: "",
      industria: "",
      titulo: "",
      fechaRegistro: new Date,
      cantCursos: 0,
    }

    userRef.ref.get().then(doc => {
      if (doc.exists) {
        // console.log('usuario Empresa existente')
        return location.reload()
      } else {
        // console.log('usuario Empresa no existente')
        return userRef.set(userData, {
          merge: true
        }).then(() => {
          location.reload()
        });
        // alert('Lo sentimos. Estamos en fase de prueba por lo que no es posible registrarse en estos momentos en Predyc.')
        // return this.SignOut()
      }
    })
  }

  // ------------------------------------------------------------------------------- SIGN OUT + AUX

  SignOut() {
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('user');
      this.router.navigate(['']);
      // document.location.href = 'https://stackoverflow.com';
    })
  }

  deleteUser() {
    const user = firebase.default.auth().currentUser;
    user.delete().then(function () {
      // console.log('usuario eliminado')
    }).catch(function (error) {
      console.log(error);
    });
    this.db.collection("usuarios").doc(user.uid).delete();
  }
}
